import { useState, useEffect, useRef, React } from 'react';
import { Grid } from '@mui/material';
import { pdfjs, Document, Page } from 'react-pdf';
import worker from 'react-pdf/node_modules/pdfjs-dist/build/pdf.worker.entry';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import PropTypes from 'prop-types';
import ProgressSpinner from '../../UI/ProgressSpinner/ProgressSpinner';

pdfjs.GlobalWorkerOptions.workerSrc = worker;

const PDFViewer = ({ PDF }) => {
    const containerRef = useRef();
    const [width, setWidth] = useState(0);
    const [numPages, setNumPages] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    const onDocumentLoadSuccess = ({ numPages: pages }) => {
        setNumPages(pages);
        setIsLoading(false);
    };

    useEffect(() => {
        if (containerRef.current) {
            setWidth(containerRef.current.offsetWidth);
        }

        const handleResize = () => {
            if (containerRef.current) {
                setWidth(containerRef.current.offsetWidth);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    return (
        <Grid item xs={12} sx={{ marginTop: '20px' }} ref={containerRef}>
            <Document file={PDF} onLoadSuccess={onDocumentLoadSuccess}>
                {Array.from({ length: numPages }, (_, index) => (
                    <Page
                        key={`page_${index + 1}`}
                        pageNumber={index + 1}
                        width={width}
                        renderTextLayer
                        renderAnnotationLayer
                    />
                ))}
            </Document>
            {isLoading && <ProgressSpinner />}
        </Grid>
    );
};
PDFViewer.propTypes = {
    PDF: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.object,
    ]).isRequired,
};

export default PDFViewer;
